Pegasus.VisibilityToggleView = Em.View.extend({
  propertyPath: 'controller.dataIsDisplayed',
  template: function() {
    var e = 'checked="checked"';
    var val = this.get( this.get('propertyPath') );
    if ( val === 'true' || val && val !== 'false'  ) {
      e = "";
    }
    var t = [
      '<div class="visibility-toggle" draggable="false">',
      '<label class="switch-light switch-candy" onmouseup="$(window).trigger(\'didToggleImageDisplayMode\');" onclick="" draggable="false">',
      '<input type="checkbox" draggable="false" ' + e + " >",
      '<span class="toggle" draggable="false"><span draggable="false">'+Em.I18n.t('g.show')+'</span><span draggable="false">'+Em.I18n.t('g.hide')+'</span><a href="javascript:void(0);" draggable="false"></a></span>',
      "</label>",
      "</div>"
    ].join("");

    return Em.Handlebars.compile(t)
  }.property()
});
